import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad2Actividad3.mp3";

const Actividad4 = () => {
  const infoUnidad = modulo13.content[1];
  const infoAct = modulo13.content[1].activities[2];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[1].name}: ${modulo13.content[1].activities[3].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[3].path}`,
    titlePrev: `${modulo13.content[1].name}: ${modulo13.content[1].activities[1].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[1].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>
          ¿Qué podríamos hacer para solucionar el problema presentado en la
          actividad anterior? Escoge una opción y explica a tu compañero,
          compañera o familiar por qué crees que es la mejor.
        </li>
      </ul>
      <div className="row mt-3 align-items-center">
        <div className="col-md-6 col-12 ">
          <Card>
            <p className="p-3 p-md-0 pb-0">
              <strong>Opción 1:</strong>
            </p>
            <p className="fs-5 p-3 p-md-0 pt-0">
              La Municipalidad decide solucionar el problema construyendo una
              planta de tratamiento del agua. Los vecinos no están bien
              informados del proceso y no vigilan que la Municipalidad cumpla.
            </p>
          </Card>
        </div>
        <div className="col-md-6 col-12 ">
          <Card>
            <p className="p-3 p-md-0 pb-0">
              <strong>Opción 2:</strong>
            </p>
            <p className="fs-5 p-3 p-md-0 pt-0">
              La Municipalidad consulta con los vecinos la propuesta de hacer
              una planta de tratamiento del agua. Los vecinos aceptan y crean un
              comité de vigilancia mientras se construye la obra.
            </p>
          </Card>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: ¿Qué podríamos hacer para solucionar el
            problema? Escoge una opción y explica a tu compañero o compañera por
            qué crees que es la mejor. Pida que lean en voz alta las dos
            opciones que se presentan. Asegúrese de que las dos opciones han
            sido comprendidas en su totalidad antes de que se tome una decisión.
            Retome las respuestas. Para ello puede preguntar lo siguiente:
            <ul>
              <li>
                <i>
                  “¿Cuál es el problema con la primera opción? (Posible
                  respuesta: Los vecinos no están involucrados con un problema
                  que los afecta directamente. No están informados sobre las
                  consecuencias de la construcción de la planta de tratamiento y
                  tampoco le hacen seguimiento al problema para que se
                  resuelva).
                </i>
              </li>
              <li>
                <i>
                  ¿Por qué resulta mejor la opción 2? (Posible respuesta: Porque
                  la Municipalidad decide consultar a los vecinos para conocer
                  sus opiniones acerca de la construcción de la planta de
                  tratamiento. Para poder dar su opinión, los vecinos deben
                  estar informados del problema y sus consecuencias. Asimismo,
                  toman acciones para vigilar que el acuerdo –la construcción de
                  la planta– se cumpla)”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
